__turbopack_context__.v({
  "favorite-icon": "favorite-module-scss-module__eUo-va__favorite-icon",
});
